import ContainerVerification from "./Components/ContainerVerification"
export default function VerificationGoogle() {
  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerVerification/>
      <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  )
}